import { render } from "./LinkageMailMagazineComplete.vue?vue&type=template&id=344a7664&ts=true"
import script from "./LinkageMailMagazineComplete.vue?vue&type=script&lang=ts"
export * from "./LinkageMailMagazineComplete.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1253990065/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__